<template>
  <a
    target="_blank"
    rel="noopener"
    :href="termsAndConditionsUrl"
    @click.stop
  ><slot>Terms &amp; Conditions</slot></a>
</template>

<script>
export default {
  name: 'TermsAndConditionsLink',
  data: function () {
    return {
      termsAndConditionsUrl: 'https://www.authentigate.io/terms-and-conditions'
    }
  }
}
</script>
